import React from 'react';
import { useEffect } from 'react';
import { Navigate, Outlet, useLocation, matchPath } from 'react-router-dom';
import withFirebase from '../../Firebase/withFirebase';
import { callNativeMobileApp, useTranslator } from '@front-activerse/common-components';
import { Route } from '../types';

/* eslint-disable-next-line */
export interface PrivateRouteProps {
  title?: string;
  mobileAppTabIdentifier?: string;
  updateScene: (
    sceneId: number,
    lastPlaybackPosition: number,
    isPlaybackCompleted: boolean,
    __typename: string
  ) => any;
  trackFirebaseEvent: any;
  descendantRoutes: Route[];
  routePath: string;
}

export function PrivateRoute(props: PrivateRouteProps) {
  const isAuth = localStorage.getItem('token');
  const location = useLocation();

  const { t } = useTranslator();

  const matchedRoute = props.descendantRoutes?.find((descendantRoute) =>
    matchPath(props.routePath.slice(0, -2) + descendantRoute.path, location.pathname)
  );

  useEffect(() => {
    // disable title change if disableTitleChangePostMsg (set in descendant routes) is true
    if (!matchedRoute?.disableTitleChangePostMsg) {
      callNativeMobileApp({
        action: 'title_changed',
        payload: {
          title: t(`${matchedRoute ? matchedRoute.title : props.title}`),
        },
      });
    }

    const lastPlayedSceneString = sessionStorage.getItem('lastPlayedAudioToUpdate');

    if (lastPlayedSceneString && !location.pathname.includes('motivation')) {
      const lastPlayedScene = JSON.parse(lastPlayedSceneString);
      const update = async () => {
        const res = await props.updateScene(
          lastPlayedScene.sceneId,
          lastPlayedScene.lastPlaybackPosition,
          lastPlayedScene.isCompleted,
          lastPlayedScene.__typename
        );

        if (res.scene.updateScenePlaybackMetadata.code === 200) {
          sessionStorage.removeItem('lastPlayedAudioToUpdate');
        }
      };

      if (lastPlayedScene) {
        update();
      }
    }
  }, [location, props]);

  return isAuth ? (
    <Outlet context={{ brand: 'resilient', trackFirebaseEvent: props.trackFirebaseEvent }} />
  ) : (
    <Navigate to="/auth/login" state={{ from: location }} />
  );
}

export default withFirebase(PrivateRoute);
